import { render, staticRenderFns } from "./CompGeneralRatingStars.vue?vue&type=template&id=545ea919&scoped=true"
import script from "./CompGeneralRatingStars.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralRatingStars.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompGeneralRatingStars.vue?vue&type=style&index=0&id=545ea919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ea919",
  null
  
)

export default component.exports